module.exports = __webpack_public_path__ + "img/bank.e1822ac1.png";